import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  colors,
} from "@mui/material";
import PropTypes from "prop-types";
import "./styles.css";
import FooterPage from "./FooterPage";

const TermsAndConditions = ({ onAccept }) => {
  const [serialNumber, setSerialNumber] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isValidInput, setIsValidInput] = useState(true);
  const [error, setError] = useState("");

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setError("");
  };
  const handleInputChange = (inputValue) => {
    if (/^[a-zA-Z0-9]*$/.test(inputValue)) {
      setSerialNumber(inputValue);
      setSerialNumber(inputValue.slice(0, 30));
      setSerialNumber(inputValue.toUpperCase());
      setIsValidInput(true);
    } else {
      setIsValidInput(false);
    }
  };
  // console.log(orderNumber)
  const handleAccept = () => {
    if (!isChecked) {
      setError("Please accept the terms and conditions.");
    } else {
      setError("");
      onAccept(serialNumber);
    }
  };

  // console.log(orderNumber)
  return (
    <Box className="terms-box">
      <div className="containertnc">
        <div className="terms-message">
          <p>
            <h3 className="tnc-privacy-headers">GM Energy Terms and Conditions</h3>
            1. Acceptance of Terms
            <br />
            These Terms and Conditions (“Terms”) are between you and General
            Motors Energy LLC (“GM Energy”, “us”, “we”, “our”) and apply to your
            use of the GM Energy website (“GM Energy” or “Site”) where these
            terms are posted and all products and services (each, a “Product”)
            purchased from the Site in the United States. You accept and agree
            to be bound by these Terms when you use our Site or purchase our
            Products. Updates: We may update these Terms from time to time by
            notifying you of such changes by any reasonable means, including by
            posting revised Terms here. You agree that it is your responsibility
            to check for any updated Terms including before placing an order or
            purchasing any Products on the Site. The “Last Updated” legend,
            above, shows when these Terms were last changed. If you purchase
            Products through GM Energy after we post any changes, you accept the
            updated Terms. You represent and warrant that you have reached the
            age of majority in your jurisdiction of residence and have full
            legal capacity to enter into binding contracts, or are at least 13
            years of age and possess legal parental or guardian consent and are
            fully able and competent to enter into and abide by these Terms. If
            you are using GM Energy on behalf of a legal entity, you represent
            that you are authorized to enter into and agree to these Terms on
            behalf of that legal entity. Important: PLEASE REVIEW THESE TERMS
            CAREFULLY. THESE TERMS INCLUDE A CLASS ACTION WAIVER WHICH MEANS
            THAT YOU AGREE TO PROCEED WITH ANY DISPUTE INDIVIDUALLY AND NOT AS
            PART OF A CLASS ACTION. THESE TERMS ALSO INCLUDE A JURY WAIVER.
            <br />
            2. Privacy
            <br />
            You acknowledge that when you install the Products, we will collect
            information, including personal information, from the Products that
            we will use, share, store, and process subject to GM Energy’s
            Privacy Statement, available at{" "}
            <a href="www.gm.com/privacy-statement">
              www.gm.com/privacy-statement
            </a>
            . This may include, for example, information about Product
            installation within your home or other installed location, your use
            of the Products, your energy usage, your charging and discharging of
            devices integrated with or connected to the Products (such as
            electric vehicles, stationary storage, and solar panels), and other
            information such as your charging preferences and rate plans that GM
            Energy may collect through mobile applications or websites made
            available in connection with the Products. You agree that your use
            of the Site and Products is subject to GM Energy’s Privacy
            Statement, which is incorporated into and made part of these Terms,
            and you agree to this Privacy Statement by using the Site or by
            using or purchasing a Product. See GM Energy’s Privacy Statement for
            more information on how GM Energy uses, shares, stores and processes
            information collected from the Products and regarding how you will
            be notified of and bound by any changes to the GM Energy Privacy
            Statement.
            <br />
            3. Accounts
            <br />
            a. To access some features of the Site, you will have to create an
            account. You may never sign on under another user's account without
            their express permission. When creating your account, you must
            provide accurate and complete information. You are solely
            responsible for the activity that occurs on your account, and you
            must keep your account password secure at all times. You should
            notify GM Energy immediately of any breach of security or
            unauthorized use of your account. b. GM Energy will not be liable
            for any losses caused to you by any unauthorized use of your
            account. However, you may be liable for the losses of GM Energy or
            other parties due to such unauthorized use.
            <br />
            4. Use of the Site
            <br />
            GM Energy grants you permission to access and use the Site as set
            forth in these Terms, provided that: a. You agree not to alter or
            modify any part of the Site. b. You agree not to access any content
            through any technology or any unauthorized means other than user
            interaction expressly invited on the Site itself. c. You agree not
            to use the Site for any prohibited commercial use. Prohibited
            commercial use includes any of the following actions taken without
            GM Energy’s express approval: (i) sale of access to the Site or its
            related services; (ii) use of the site or its related services for
            the primary purpose of gaining advertising or subscription revenue;
            (iii) sale of advertising on the Site or any third party website
            targeted to Site content; (iv) any use of the Site or its related
            services that GM Energy finds, in its sole discretion, to use GM
            Energy resources with the effect of competing with or displacing the
            market for the Site content or Products or services featured on the
            Site. d. You agree not to use or launch any automated system,
            including without limitation, "robots," "spiders," or "offline
            readers," that accesses the Site in a manner that sends more request
            messages to the Site in a given period of time than a human can
            reasonably produce in the same period by using a conventional online
            web browser. Notwithstanding the foregoing, GM Energy grants the
            operators of public search engines permission to use spiders to copy
            materials from the site for the sole purpose of and solely to the
            extent necessary for creating publicly available searchable indices
            of the materials, but not caches or archives of such materials. GM
            Energy reserves the right to revoke these exceptions either
            generally or in specific cases. You agree not to collect or harvest
            any personally identifiable information, including account names,
            from the Site, nor to use any communication system provided by the
            Site (e.g. comments, email) for any commercial solicitation
            purposes. You agree not to solicit, for commercial purposes, any
            users of the Site with respect to their user submissions to the
            Site. e. You will otherwise comply with the terms and conditions of
            these Terms, and all applicable local, state, national, and
            international laws and regulations. f. GM Energy reserves the right
            to discontinue any aspect of the Site at any time.
            <br />
            5. Site Content
            <br />
            In addition to the general restrictions above, the following
            restrictions and conditions apply specifically to your use of
            content on the Site: a. The content on the Site, including without
            limitation, Product information and descriptions, text, data,
            software, scripts, graphics, photos, sounds, music, videos,
            interactive features and the like ("Content") and the trademarks,
            service marks and logos contained therein ("Marks"), are owned by or
            licensed to GM Energy, subject to copyright and other intellectual
            property rights under the law. b. You may access Site Content and
            other content only as permitted under these Terms. GM Energy
            reserves all rights not expressly granted in and to the Site
            Content. c. You agree not to engage in the use, copying, or
            distribution of any of the Content other than as expressly permitted
            herein, including any use, copying, or distribution of content of
            third parties obtained through the Site for any commercial purposes.
            d. You agree not to circumvent, disable or otherwise interfere with
            security-related features of the Site or features that prevent or
            restrict use or copying of any Content or enforce limitations on use
            of the Site or the Content contained in the Site. e. The Content is
            for educational and informational purposes only, and errors may
            appear from time to time. Before you act in reliance on the Content,
            you should confirm any facts that are important to your decision. GM
            Energy makes no warranty as to the reliability, accuracy,
            timeliness, usefulness or completeness of any Content. f. The Site
            may contain links to third-party websites that are not owned or
            controlled by GM Energy. GM Energy has no control over, and assumes
            no responsibility for, the content, privacy policies, or practices
            of any third-party websites. By clicking on links, you expressly
            relieve GM Energy from any and all liability arising from your use
            of any third-party site, or from the content of any third party
            site.
            <br />
            6. Procedure for Making
            <br />
            a Claim of Copyright Infringement To file a copyright infringement
            notification with us, you will need to send a written communication
            that contains the following: a. A physical or electronic signature
            of a person authorized to act on behalf of the owner of an exclusive
            right that is allegedly infringed. b. Identification of the
            copyrighted work claimed to have been infringed. c. Identification
            of the material on our Site that is claimed to be infringing, with
            information reasonably sufficient to allow us to locate the
            material. d. Information reasonably sufficient to permit us to
            contact the complaining party, such as an address, telephone number
            and, if available, an electronic mail address at which the
            complaining party may be contacted. e. A statement that the
            complaining party has a good faith belief that use of the material
            in the matter complained of is not authorized by the copyright
            owner, its agent or the law. f. A statement that the information in
            the notification is accurate, and under penalty of perjury, that the
            complaining party is authorized to act on behalf of the owner of an
            exclusive right that is allegedly infringed. Such written
            notification should be sent to: Lauren Latimer General Motors LLC
            300 Renaissance Center Detroit, MI 48265 Phone: 313-665-4699 Email:
            lauren.latimer@gm.com Counter Notice: If you believe that your user
            submission which was removed from the Site in response to a
            Copyright Infringement Notification is not infringing, or that you
            have the authorization from the copyright owner, the copyright
            owner’s agent, or pursuant to law, to post and use the content in
            your User Submission, you may send a counter-notice to GM Energy
            containing the following information: Your physical or electronic
            signature Identification of your user submission which was removed A
            statement that you have a good faith belief that the content was
            removed as a result of a mistake or misidentification of the
            content. Your name, address, telephone number and email address. A
            statement that you consent to the jurisdiction of the federal court
            in Detroit and a statement that you will accept service of process
            from the person who provided notification of the alleged
            infringement. If a Counter-Notice is received by GM Energy, GM
            Energy may send a copy to the original complaining party, informing
            them that the objected to user submission may be reposted in 10
            business days. Unless the copyright owner files an action seeking a
            court order against you to restrain your allegedly infringing
            activity, your user submission may be reposted at GM Energy’s sole
            discretion.
            <br />
            7. Site Warranty Disclaimer
            <br />
            YOU AGREE THAT YOUR USE OF THE SITE SHALL BE AT YOUR SOLE RISK. TO
            THE FULLEST EXTENT PERMITTED BY LAW, GM ENERGY, ITS OFFICERS,
            DIRECTORS, EMPLOYEES, PARENTS, AFFILIATES, SHAREHOLDERS,
            REPRESENTATIVES AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR
            IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE OF IT. GM ENERGY
            MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
            COMPLETENESS OF ANY CONTENT OR THE CONTENT OF ANY SITES LINKED TO
            THIS SITE AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY (I)
            ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY
            OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR
            ACCESS TO AND USE OF THE SITE, (III) ANY UNAUTHORIZED ACCESS TO OR
            USE OF OUR SECURE SERVERS OR ANY AND ALL PERSONAL INFORMATION OR
            FINANCIAL INFORMATION STORED IN SUCH SERVERS, (IV) ANY INTERRUPTION
            OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (IV) ANY BUGS,
            VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR
            THROUGH THE SITE BY ANY THIRD PARTY, OR (V) ANY ERRORS OR OMISSIONS
            IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
            RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR
            OTHERWISE MADE AVAILABLE VIA THE SITE. GM ENERGY DOES NOT WARRANT,
            ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR
            SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE OR
            ANY HYPERLINKED SITE OR FEATURED IN ANY BANNER OR OTHER ADVERTISING,
            AND GM ENERGY WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE
            FOR MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD PARTY PROVIDERS
            OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR
            SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE
            YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
            <br />
            8. Sale of Products and Services
            <br />
            a. OrderAcceptance and Cancellation. You agree that your order is an
            offer to buy under these Terms all Products listed in your order. GM
            Energy may choose not to accept any order in its sole discretion. GM
            Energy may send an order confirmation by email or other means to
            acknowledge the receipt of an order, but GM Energy does not accept
            any order until notice is sent notifying you that the ordered
            Product has shipped. In the event an Order contains multiple
            Products, GM Energy may process payment for and ship each Product
            separately. GM Energy reserves the right to at any time, even after
            your order is confirmed by email or other means, to cancel your
            order or any portion thereof for any reason, including error or
            suspected fraud, and return the applicable associated payment. b.
            Availability of Products. Due to offers that are limited in time or
            availability, certain Products described on the Site may not be
            available to all users at all times. GM Energy may provide certain
            summary descriptions or other helpful information regarding
            Products. We attempt to be as accurate as possible; however, any
            such materials are intended to generally describe Products. GM
            Energy does not warrant that product descriptions or other content
            of GM Energy is accurate, complete, reliable, current, or
            error-free. PRICES AND AVAILABILITY OF PRODUCTS LISTED WITHIN AND ON
            GM ENERGY ARE SUBJECT TO CHANGE WITHOUT NOTICE. The listing,
            description of, or reference to, a Product on GM Energy does not
            imply that such Product is presently available. In the event a
            Product ordered is no longer available for purchase, we will either
            contact you or cancel your order. All orders of Products are subject
            to prevailing law, including, as appropriate, export and import
            regulations and boycotting restrictions, if any, imposed by
            governing bodies having jurisdiction over such orders, products or
            services. c. Shipments; Delivery; Title and Risk of Loss. GM Energy
            will arrange for shipment of ordered Products to you. Shipping and
            delivery dates are estimates only and cannot be guaranteed. GM
            Energy is not liable for any delays in shipment. Title and risk of
            loss for a Product pass to you when payment is received in
            accordance with the selected Payment Method, and the Product is
            shipped. d. Cancellations. You may request to cancel your order for
            GM Energy Products at any time prior to your GM Energy products
            having shipped by notifying a GM Energy Service Agent at
            (833)64POWER. In the event your Products have already shipped, your
            order will not be cancelled. In the event your cancellation request
            is processed, you may receive confirmation by email at the email
            address associated with your GM Energy account. If you have already
            made a payment on your order, you will be entitled to a full refund,
            except for any non-refundable portion of any Installation Deposit
            paid to any third-party installation provider on the Site. Your
            refund will be issued to the same credit card used to make the
            purchase within 30 days of GM Energy’s acceptance of your
            cancelation request. e. Returns. You may initiate a return of the GM
            Energy Products within 14 days following delivery, subject to the
            terms and conditions contained herein. To initiate a return and
            schedule shipping, please contact a GM Home Energy Consultant at
            (833)64POWER. Any returned products must be undamaged, in its
            original (as received), unopened packaging, in new, non-installed,
            resalable condition, with all instructions, paperwork and hardware.
            If all of these conditions are not met or any return is incomplete,
            GM Energy may choose not to accept your return. Shipping costs are
            non-refundable. GM Energy has no responsibility for returned
            Product(s) that are lost or damaged during transit, and such losses
            and damages are solely your responsibility. In addition, all
            accepted returns will be subject to a restocking fee equal to 15% of
            the purchase price of the returned Product(s). Once GM Energy has
            received and inspected your item(s), if it determines that all
            return requirements have been satisfied, your refund of payments for
            the returned GM Energy products will be issued, minus the 15%
            restocking fee. For payments made by credit card or debit card, GM
            will process your refund on the same card used to make the purchase
            within 30 days of receipt of your returned items. If you return
            Products financed through GM Financial, GM Energy will send a refund
            for the returned Product(s) directly to GM Financial to be applied
            to your loan. However, you will still be responsible for paying GM
            Energy a 15% restocking fee. You will not be entitled to a refund of
            any non-refundable portions of the Installation Deposit paid to any
            third-party installation provider on our Site in connection with
            your order. f. Payment and Order Acceptance. i. You agree to pay for
            your Products on GM Energy with a valid credit card, debit card, or
            other payment method that GM Energy may permit (each, a “Payment
            Method”). By providing payment card information to us, you authorize
            us to store and use the card as a Payment Method for purchases made
            through your account, including on GM Energy affiliated sites and
            properties which you access via your GM Energy account credentials.
            GM Energy participates in account updater services offered by some
            banks. If your bank participates in account updater services, these
            services will automatically update your card number or expiration
            date in our system when it changes. If you do not want to have your
            cards automatically updated, you can opt out of these services by
            contacting your issuing bank. You authorize GM Energy to confirm
            that your Payment Method is valid, including by submitting a payment
            authorization request in accordance with the relevant rules for your
            Payment Method, such as the network rules for Visa or MasterCard
            (“Network”). GM Energy will charge your Payment Method for the price
            of the Products, plus any applicable fees and taxes, as set forth in
            the offer you accepted. GM Energy may change the Payment Methods it
            accepts through GM Energy at any time, in its sole discretion. GM
            Energy will share your Payment Method information with GM Energy’s
            payment processor and the Networks as necessary to facilitate
            payment for Products. ii. If, for any reason, your payment cannot be
            charged to your Payment Method (for instance, in case of
            insufficient funds or lack of available credit), GM Energy reserves
            the right to cancel your order. GM Energy may contact you if your
            order is canceled or if additional information is required to accept
            your order. g. Tax Policy. Unless stated otherwise, prices for all
            Products are in United States dollars and exclude any and all
            applicable taxes and shipping and handling charges, unless expressly
            stated otherwise. To the extent permissible under law, you are
            responsible for any applicable taxes, whether or not they are listed
            on your receipt or statement. GM Energy charges sales tax on all
            orders as required by law. h. Intellectual Property Ownership. You
            acknowledge and agree that you do not and will not have or acquire
            any ownership of any intellectual property rights in and to any
            Product made available on GM Energy and any related specifications,
            instructions, documentation or other materials, including, but not
            limited to, all related copyrights, patents, and trademarks and
            other intellectual property rights. i. Product Warranty; Disclaimer
            i. The Products are subject to the terms of GM Energy’s Standard
            Limited Warranty (the “Warranty”), which is as follows: GM Energy
            PowerShift Charger – 3 year limited warranty GM Energy V2H
            Enablement Kit – 10 year limited warranty GM Energy PowerBank – 10
            year limited warranty All applicable warranties with respect to the
            Products are set forth in the GM Energy Product Warranty. ii. You
            acknowledge and agree that in order to obtain warranty and/or other
            maintenance services for the Products following the expiration of
            the Warranty, you must purchase extended protection plans directly
            from GM Energy or an affiliate thereof (subject to availability).
            iii. YOU ACKNOWLEDGE THAT, EXCEPT AS SET FORTH IN THIS SECTION
            (iii), ALL PRODUCTS ARE PROVIDED BY GM ENERGY ON AN “AS IS” BASIS,
            AND TO THE FULLEST EXTENT PERMITTED BY LAW, GM ENERGY, ITS OFFICERS,
            DIRECTORS, EMPLOYEES, PARENTS, AFFILIATES, SHAREHOLDERS,
            REPRESENTATIVES AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR
            IMPLIED, IN CONNECTION WITH THE PRODUCTS, INCLUDING, WITHOUT
            LIMITATION, ANY WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A
            PARTICULAR PURPOSE, NON-INFRINGEMENT, SATISFACTORY QUALITY, TIMELY,
            ACCURATE, OR ERROR-FREE OPERATION, OR FREEDOM FROM COMPUTER VIRUS OR
            MALICIOUS CODE. j. Goods Not for Resale or Export. You agree to
            comply with all applicable laws and regulations of the various
            states and of the United States including all Export Regulations, as
            defined below. You represent and warrant that you are buying
            products or services from GM Energy for your own personal or
            household use only, and not for resale or export. Products and
            services purchased from GM Energy may be controlled for export
            purposes by export regulations, including but not limited to, the
            Export Administration Act of 1979 (50 U.S.C. 2401-2410), the Export
            Administration Regulations promulgated thereunder (15 C.F.R.
            768-799), the International Traffic in Arms Regulations (22 C.F.R.
            120-128 and 130) and their successor and supplemental regulations
            (collectively, "Export Regulations").
            <br />
            9. Software Updates
            <br />
            Your Products involve software, data, and related settings
            (collectively, the “Software”) that GM Energy makes available to
            you. The Software is licensed, not sold to you, and may need to be
            updated or changed from time to time. You agree that we may remotely
            access, deliver, install, update or change the Software (such
            actions collectively referred to as “Updates”) without any further
            notice or consent. For example, these Updates may enhance safety or
            security, or may maintain the proper operation of your Products.
            These Updates may affect or erase data that you have stored in your
            Products (such as your charging preferences or other settings). We
            are not responsible for any affected or erased data due to an
            Update. If we provide further notice or request further consent to
            an Update, the notice or consent may be received or provided by any
            permitted user of the Products (a “Permitted User”) on behalf of you
            and all Permitted Users. You and the Permitted User receiving or
            providing that notice or consent are responsible for notifying all
            other Permitted Users of the provided notice and consent. However,
            you agree that in any case, we may make Updates without additional
            notice or consent. These Terms will govern any Updates or other
            changes we make to the Software and Products for all Permitted
            Users.
            <br />
            10. Limitation of Liability
            <br />
            IN NO EVENT SHALL GM ENERGY, OR ITS PARENTS, SUBSIDIARIES,
            AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS, BE LIABLE TO
            YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR
            CONSEQUENTIAL DAMAGES WHATSOEVER RESULTING FROM ANY CLAIM THAT ANY
            PRODUCT VIOLATES ANY WARRANTY IMPOSED BY STATUTE. THE FOREGOING
            LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED
            BY LAW IN THE APPLICABLE JURISDICTION. OUR TOTAL LIABILITY TO YOU IN
            CONNECTION WITH ANY CLAIM THAT A PRODUCT VIOLATES ANY WARRANTY
            IMPOSED BY STATUTE WILL BE LIMITED TO THE AMOUNT YOU HAVE PAID FOR
            THE PRODUCT AT ISSUE. YOU ALSO ACKNOWLEDGE AND AGREE THAT YOU HAVE
            PURCHASED PRODUCTS WITH A FULL UNDERSTANDING OF THE LIMITATION OF
            OUR LIABILITY IN THIS AGREEMENT.
            <br />
            11. Indemnification
            <br />
            TO THE FULL EXTENT PERMITTED UNDER APPLICABLE LAW, YOU AGREE TO
            DEFEND, INDEMNIFY, AND HOLD HARMLESS GM ENERGY, ITS PARENTS,
            SUBSIDIARIES, AFFILIATES, AND EACH OF THEIR RESPECTIVE OFFICERS,
            DIRECTORS, EMPLOYEES, AND AGENTS FROM AND AGAINST ANY AND ALL SUITS,
            ACTIONS, CLAIMS, PROCEEDINGS, DAMAGES, SETTLEMENTS, JUDGMENTS,
            INJURIES, LIABILITIES, OBLIGATIONS, LOSSES, RISKS, COSTS, AND
            EXPENSES (INCLUDING, WITHOUT LIMITATION, REASONABLE ATTORNEYS’ FEES
            AND LITIGATION EXPENSES) RELATING TO OR ARISING FROM USE OF THE
            SITE, OR USE OF ANY PRODUCT NOT IN ACCORDANCE WITH THE APPLICABLE
            MANUFACTURER’S INSTRUCTIONS, YOUR FRAUD, VIOLATION OF LAW, OR
            WILLFUL MISCONDUCT, AND ANY BREACH BY YOU OF THESE TERMS.
            <br />
            12.
            <br />
            Notices Any notices to you from GM Energy regarding GM Energy or
            these Terms will be posted on GM Energy or made by email or regular
            mail to the address(es) provided by you at the time of order.
            <br />
            13.
            <br />
            Copyright/Trademark Copyright 2024 General Motors. All Rights
            Reserved. All text, images, graphics, animation, videos, music and
            other materials on this Site are subject to the copyright and other
            intellectual property rights of GM. These materials may not be
            reproduced, distributed, modified or reposted to other websites
            without the express written permission of GM. The marks appearing on
            this Site including, but not limited to: (i) GM and the GM Logo;
            (ii) Chevrolet, Buick, Cadillac, GMC and their respective logos,
            emblems, slogans and vehicle model names and body designs; (iii) GM
            Energy and the GM Energy Logo; and (iv) other marks such as ACDelco
            and OnStar are trademarks or service marks of GM, its subsidiaries,
            affiliates or licensors.
            <br />
            14. General Provisions a. Entire Agreement.
            <br />
            Any order confirmation, these Terms and our Privacy Statement and
            any other legal notices published by GM Energy on this Site
            constitute the entire agreement between GM Energy and you in
            connection with your use of the Site and purchase of Products. b.
            Governing Law; Jurisdiction; Venue; Severability of Provisions. The
            Terms are governed by the laws of the State of Michigan, USA without
            regard to any conflicts of law provisions. Any legal proceedings
            arising from or relating to these Terms shall be brought exclusively
            in the federal or state courts of Michigan and we both consent to
            the personal jurisdiction and venue of such courts. All parts of
            these Terms apply to the maximum extent permitted by law. We both
            agree that if any provision of these Terms is found by a court of
            competent jurisdiction to be unenforceable as written, these Terms
            shall not be invalid or void, but such provision will be severed,
            and the remainder of these Terms shall remain in full force and
            effect. The section headings are for convenience and do not have any
            force or effect. c. Class Action Waiver. TO THE FULL EXTENT
            PERMITTED BY APPLICABLE LAW, BOTH YOU AND GM ENERGY WAIVE THE RIGHT
            TO BRING ANY DISPUTE AS A CLASS, CONSOLIDATED, REPRESENTATIVE,
            COLLECTIVE, OR PRIVATE ATTORNEY GENERAL ACTION, OR TO PARTICIPATE IN
            A CLASS, CONSOLIDATED, REPRESENTATIVE, COLLECTIVE, OR PRIVATE
            ATTORNEY GENERAL ACTION REGARDING ANY DISPUTE BROUGHT BY ANYONE
            ELSE. IF THE PROVISION REGARDING WAIVER OF CLASS, COLLECTIVE,
            REPRESENTATIVE, AND PRIVATE ATTORNEY GENERAL CLAIMS OF THIS SECTION
            IS FOUND TO BE VOID OR OTHERWISE UNENFORCEABLE, ANY SUCH CLASS,
            COLLECTIVE, REPRESENTATIVE, OR PRIVATE ATTORNEY GENERAL CLAIMS MUST
            BE HEARD AND DETERMINED THROUGH AN APPROPRIATE COURT PROCEEDING, AND
            NOT IN ARBITRATION. d. Jury Waiver. TO THE FULL EXTENT PERMITTED BY
            APPLICABLE LAW, GM ENERGY AND YOU EACH WAIVE THEIR RIGHT TO JURY
            TRIAL WITH RESPECT TO ALL CLAIMS AND ISSUES ARISING UNDER, IN
            CONNECTION WITH, TOUCHING UPON OR RELATING TO THESE TERMS, THE
            BREACH THEREOF AND/OR THE SCOPE OF THE PROVISIONS OF THIS SECTION,
            WHETHER SOUNDING IN CONTRACT OR TORT, AND INCLUDING ANY CLAIM FOR
            FRAUDULENT INDUCEMENT THEREOF. e. Time Limitation on Claims. YOU
            AGREE THAT ANY CLAIM YOU MAY HAVE ARISING OUT OF OR RELATED TO YOUR
            PURCHASE OF ANY PRODUCT OR YOUR RELATIONSHIP WITH GM ENERGY MUST BE
            FILED WITHIN ONE YEAR AFTER SUCH CLAIM AROSE; OTHERWISE, YOUR CLAIM
            IS PERMANENTLY BARRED. f. Remedies. You agree that any violation, or
            threatened violation, by you of these Terms will cause us
            irreparable and unquantifiable harm. You also agree that monetary
            damages would be inadequate for such harm and consent to our
            obtaining any injunctive or equitable relief that we deem necessary
            or appropriate. These remedies are in addition to any other remedies
            we may have at law or in equity. g. Force Majeure. We will not be
            liable or responsible to you, nor be deemed to have defaulted or
            breached these Terms, for any failure or delay in our performance
            under these Terms when and to the extent such failure or delay is
            caused by or results from acts or circumstances beyond our
            reasonable control, including, without limitation, acts of God,
            flood, fire, earthquake, explosion, governmental actions, war,
            invasion or hostilities (whether war is declared or not), terrorist
            threats or acts, riot or other civil unrest, national emergency,
            revolution, insurrection, epidemic, lockouts, strikes or other labor
            disputes (whether or not relating to our workforce), or restraints
            or delays affecting carriers or inability or delay in obtaining
            supplies of adequate or suitable materials, materials or
            telecommunication breakdown or power outage. h. Waiver. No waiver of
            any term of these Terms shall be deemed a further or continuing
            waiver of such term or any other term, and GM Energy’s failure to
            assert any right or provision under these Terms shall not constitute
            a waiver of such right or provision. i. Assignment. These Terms may
            not be transferred or assigned by you, but may be assigned by GM
            Energy without restriction. No assignment or transfer relieves you
            of any of your obligations under these Terms. j. No Third Party
            Beneficiaries. These Terms do not and are not intended to confer any
            rights or remedies upon any person other than you. Contacting Us. If
            you have any questions or concerns about these Terms, please contact
            us at energyservice@gm.com. We will attempt to respond to your
            questions or concerns promptly after we receive them.
          </p>
        </div>
        <div className="terms-message">
          <p>
            <h3 className="tnc-privacy-headers">General Motors U.S. Consumer Privacy Statement</h3>
            We envision a world with zero crashes, zero
            emissions and zero congestion. To achieve this bold vision, evolve
            our vehicles, and create safer experiences for you and others, we
            collect information about you and the world around you that we need
            to power the products and services we offer, to improve your
            experience in your vehicle, and to advance future technologies like
            electric vehicles and autonomous driving. We are committed to
            providing you with a trusted experience and respecting your privacy
            when it comes to personal information. When we say Personal
            Information, we mean information that identifies, relates to, or
            could reasonably be linked to you. This Privacy Statement includes
            details about: • Personal Information we collect from and about you
            • How we use this Personal Information to deliver products and
            services, keep vehicles and roadways safe, and innovate and evolve
            our vehicles for the next generation • How and when we may disclose
            Personal Information, and • Your choices and rights regarding
            privacy and access to Personal Information about you De-identified
            data: We may use privacy-enhancing and technical protection measures
            like de-identification to prevent data from being reasonably
            associated with you or your vehicle. When we de-identify data, we
            take reasonable steps to help ensure that the deidentified data is
            not re-identified and require the same commitment from any third
            parties to which we disclose de-identified data. De-identified data
            is not Personal Information. I. What this Privacy Statement covers
            GM affiliates: Our Privacy Statement covers Personal Information
            that GM collects online and offline across all GM brands of
            products, services, websites and apps. When we say GM, we mean
            General Motors Holdings LLC and its affiliates based in the United
            States. These include brands like Cadillac, Buick, GMC, Chevrolet,
            OnStar, Envolve, ACDelco, Car Bravo, and Future Roads. Additional
            Information for California Consumers: This supplements the Privacy
            Statement for California consumers and is available
            <a href="https://www.gm.com/california-privacy-statement">
              {" "}
              here
            </a>{" "}
            Washington Health Policy: Our Washington Health Policy supplements
            this Privacy 2 Statement and is available
            <a href="https://www.gm.com/washington-health-policy"> here</a> What
            This Privacy Statement Doesnt Cover Certain GM affiliates: This
            Privacy Statement does not apply to products or services offered by
            GM Financial, General Motors Insurance, or Cruise. Please review
            their privacy statements available on their websites. GM dealers:
            Dealers that sell or lease GM vehicles are separate legal entities
            from GM with their own privacy practices. This Privacy Statement
            does not apply to any GM dealer and its collection, use, or sharing
            of Personal Information. We encourage you to contact your GM dealer
            if you have questions about its privacy practices. Third-party
            services: Through the use of GM products and services, you may be
            able to access third party services, applications, and websites not
            offered or controlled by GM. These may be available to you on your
            vehicle, such as your carrier data plan, navigation services, or
            apps available to download such as through an app store on your
            connected vehicle. We recommend that you review the privacy
            disclosures and permissions of these third-party services before
            using them or providing Personal Information to them. Unless
            otherwise expressly stated by GM, this Privacy Statement does not
            apply to your use of these third-party services or any Personal
            Information third-party services may collect, use, or disclose. GM
            employees and candidates for employment: Candidates for employment
            at GM have a separate privacy statement and should visit
            <a href="https://searchcareers.gm.com/en/privacy/">
              {" "}
              https://searchcareers.gm.com/en/privacy/
            </a>
            to learn more. Current and former GM employees can find the privacy
            statement applicable to their relationship with GM on the company
            intranet site or via their human resources representative. II.
            Personal Information we collect GM offers a variety of products,
            apps and services. GM may collect Personal Information directly from
            you or automatically through your interaction with our products or
            services or we may receive Personal Information from: dealers,
            licensors, service providers, business partners, advertising
            platforms or third-party sources. For example, GM collects Personal
            Information about you when you: • Interact with us online, including
            while researching and shopping for products and services, engaging
            with our call centers, interacting with your GM account, interacting
            with email or other marketing and promotional activities, and
            participating in the My GM Rewards loyalty program • Buy or lease a
            GM vehicle from GM dealers • Have your vehicle serviced by a GM
            dealer or other business that you may use to maintain or service
            your GM vehicle • Enroll in OnStar and use OnStar services 3 • Use
            other products and services GM develops, including our myChevrolet,
            myBuick, myGMC or myCadillac vehicle mobile apps (Vehicle Mobile
            Apps) or our Home Energy Products, such as vehicle-to-home solutions
            or stationary home energy storage (collectively, Home Energy
            Products), or connect non-GM products such as your solar panels to
            our Home Energy Products We may combine information that we receive
            from various sources, including third-party sources, with
            information you provide and use or disclose it for the purposes
            identified in this Privacy Statement. The types of Personal
            Information that GM collects about you when you interact with us
            include: • Identifiers: Can include name, postal address, email
            address, screen name, photo, account ID, customer number, or
            telephone number. In limited circumstances, GM may collect a Social
            Security Number, for example if you win a sweepstakes or receive
            compensation that must be reported for government tax purposes. •
            Digital Activity Information: Can include IP address, browser type,
            unique device identifier, cookie data, associated identifying and
            usage information of computers and mobile devices that interact with
            our products, and information about how you use our products and
            services, such as infotainment system usage, Wi-Fi data usage, and
            information about your use of Vehicle Mobile Apps. • Vehicle
            Information: Can include information about your vehicle or
            information that is obtained from your vehicle that is linked to you
            or can reasonably be linked to you. For example, we may be able to
            link information to you from your vehicle, including license plate
            number and vehicle identification number (VIN), or vehicle status,
            including mileage, oil/battery status, ignition, window, door/trunk
            lock status, vehicle diagnostic information, EV charging and
            discharging and stationary energy storage details. • Geolocation
            Information: Information that is your geographic location, including
            the location of a vehicle or other device that is linked to you or
            can reasonably be linked to you. When location services are enabled
            in your vehicle, we collect Geolocation Information while the
            vehicle is used and upon the occurrence of certain events. Some
            model year 2019 and later vehicles may have an option to disable
            location services. If you disable location services, we collect
            Geolocation Information only in the event of an emergency (such as
            in the event of a crash or when the emergency call button is
            pressed). Consult your vehicle Owner’s Manual for more information.
            In addition, when you use Vehicle Mobile Apps, we may collect mobile
            device Geolocation Information, such as location and speed based on
            your device’s GPS sensors. • Demographic or Protected Classification
            Information: Can include gender, date of birth, marital status,
            household composition, or veteran or military status. We may collect
            demographic or protected classification information when you respond
            to surveys or market research, interact with our websites and
            shopping tools, sign 4 up for a GM account, participate in My GM
            Rewards, or enroll in OnStar. • Commercial Information: Can include
            (a) information about vehicle purchases or leases, information about
            financing your vehicle, and information shared with us about your
            vehicle when it is serviced by a GM dealer or other business that
            you may use to maintain or service your GM vehicle, such as service
            history, mileage, and diagnostic information, (b) relationships that
            you have with third parties in connection with your use of GM
            products and services, such as GM dealers, energy utilities, and
            companies offering or operating in-vehicle applications, (c)
            information about your accounts with us, (d) relationships you have
            with GM in addition to the purchase and servicing of your vehicle,
            such as My GM Rewards, a My GM Rewards Card, or OnStar or (e)
            information about how you use our products and service such as home
            energy usage and related home charging preferences, or records of
            your use of public charging. • Driver Behavior Information:
            Information about how you drive a vehicle that is linked or
            reasonably linkable to you, such as vehicle speed, seat belt usage,
            and information about braking habits. • Audio or Video Information:
            Can include recordings of when you speak with our customer call
            centers or OnStar advisors to deliver safety and security services,
            in the event of, for example, a vehicle crash or health or safety
            emergency, or photographs and videos such as those that you may
            submit for contests, sweepstakes, and social sharing, voice command
            details and Vehicle Camera Information, which includes (a) Camera
            Images (external camera images or video collected only in the event
            of a safety event or a crash) and (b) Camera Data (data other than
            pictures or video that is data derived from the cameras and related
            sensors). We collect external Camera Images only upon the occurrence
            of specific crash or safety events. We do not collect Camera Images
            from any sensors on the interior of your vehicle, such as the
            sensors integrated into the Super Cruise Driver Monitoring System,
            but we may collect non-image Camera Data from these sensors. •
            Payment Information: Can include your credit card information. We
            may collect payment information when you interact with our websites
            and shopping tools, get a GM account, participate in My GM Rewards
            or enroll in OnStar. Cookies & Tracking Technologies GM may use
            tracking technologies, such as cookies and pixel tags, on our
            websites, applications, email messages and advertisements, sometimes
            across devices, to gather information about your visit, such as your
            activity in our Vehicle Mobile Apps, browser type, IP address, pages
            visited, activities conducted on the page, and the day and time of
            your visit. The tracking technologies we place in our emails help
            measure the effectiveness of our email campaigns by identifying the
            individuals who open or act upon an email message, when an email
            message is opened, how many times an email message is forwarded, the
            5 type of software, device, operating system and browser used to
            deliver the email, and any URL accessed through our email message.
            We use and disclose the information collected by these tracking
            technologies, in some cases together with other information that we
            collect online and offline about you, for the purposes described in
            this Privacy Statement, including to help us reach you on
            third-party advertising networks. The third-party advertising
            networks and other businesses who operate some of these tracking
            technologies may also compile information about you that is used to
            personalize ads delivered to you on third-party websites. Event Data
            Recorder (EDR) Information Vehicles are required to include EDR
            systems that capture details in the event of an accident. GM does
            not collect Personal Information from your vehicles EDR system
            without your consent. For additional information about EDR data,
            please see your owners manual. III. How we use this Personal
            Information The Personal Information GM collects may be used for the
            following purposes: Products and services • Provide our products,
            programs, and services, such as to access your GM Account, save a
            vehicle configuration, use vehicle diagnostic tools, access OnStar
            advisors, enable in-vehicle connectivity, enable entertainment or
            navigation and stolen vehicle assistance, or, if you have an
            electric vehicle, to deliver charging programs • Develop new
            products and services, including connected, autonomous, and
            carsharing products and services • Provide customer and vehicle
            support and services (such as recall information) • Administer and
            validate warranties • Provide information and product updates •
            Conduct internal research to develop, improve, or repair products,
            services, or technology • Evaluate or improve the quality, safety,
            and security of our vehicles, products, and services • For
            operations, compliance, or warranty purposes Communication,
            marketing, and advertising • Marketing and analytics purposes •
            Maintain customer relationships and communicate with you • Customize
            and improve communication content and your experience with GM •
            Provide you with marketing offers that may interest you, including
            offers relevant to location of your vehicle or device • Provide more
            useful and relevant advertising to you on our and non-GM websites 6
            about the products and services we offer • Measure site activity,
            provide a better user experience, and tailor our marketing
            communications • Evaluate our online advertising campaigns or tailor
            promotions and other marketing messages to you across your devices •
            Administer your participation in contests, quizzes, surveys,
            promotions, and offers Purchasing, rewards, and incentive programs •
            Verify eligibility for vehicle purchase or incentive programs •
            Verify eligibility for a My GM Rewards Card and to provide My GM
            Rewards Card account management services • To support the electronic
            signature and delivery process between you and your dealer •
            Facilitate and support GM dealer and supplier diversity programs and
            GM grant programs • Enroll you in programs, services, or memberships
            with businesses that can assist with how you use your electric
            vehicle (such as energy utility companies and charge station
            operators) Web and account features • Administer your account(s) and
            process your payments for products and services • Operate our
            websites and applications, including online registration processes •
            Improve your online experiences, such as autofill data fields on our
            websites • Maintain your account log-in information or contact
            information on Request a Quote forms between visits or locating a
            nearby dealer Safety, compliance, and legal • Protect the safety of
            you or others • Evaluate or conduct a merger, divestiture,
            acquisition, restructuring, reorganization, dissolution, or other
            sale or transfer of some or all of our assets • Comply with legal,
            regulatory, or contractual requirements • Protect our rights, such
            as investigating, establishing, exercising, preparing for, or
            defending legal claims • Prevent, detect, protect against, or
            respond to security incidents, identity theft, harassment, malicious
            or deceptive activities, or any illegal activity; and preserve the
            integrity or security of systems; or investigate, report, or
            prosecute those responsible for any such action Connected vehicle
            Personal Information uses When you enroll in OnStar, GM may use
            Driver Behavior Information, precise Geolocation Information, and
            Camera Images for the limited purposes outlined below. 7 Driver
            Behavior Information We use Driver Behavior Information for the
            following categories of limited purposes: • To deliver our products
            and services where Driver Behavior Information is reasonably
            necessary or otherwise compatible with your reasonable expectations
            • As reasonably necessary to protect the safety, property, or rights
            of us, our customers, or members of the public • For operations,
            compliance, or warranty purposes • For internal research or product
            development • To prevent, detect, protect against, or respond to
            security incidents, identity theft, harassment, malicious or
            deceptive activities, or any illegal activity; and preserve the
            integrity or security of systems; or investigate, report, or
            prosecute those responsible for any such action • Comply with legal,
            regulatory, or contractual requirements • Protect our rights, such
            as investigating, establishing, exercising, preparing for, or
            defending legal claims Precise Geolocation Information We use
            precise Geolocation Information for the following categories of
            limited purposes: • To deliver our products and services where
            precise Geolocation Information is reasonably necessary or is
            otherwise compatible with your reasonable expectations (such as
            vehicle locate features in our Vehicle Mobile Apps, and to provide
            turn-by-turn routing information to you via OnStar or to assist in
            the location or recovery of a vehicle reasonably identified as
            stolen) • As reasonably necessary to protect the safety, property,
            or rights of us, our customers, or members of the public • For
            operations, compliance, or warranty purposes • For internal research
            or product development • To prevent, detect, protect against, or
            respond to security incidents, identity theft, harassment, malicious
            or deceptive activities, or any illegal activity; preserve the
            integrity or security of systems; or investigate, report, or
            prosecute those responsible for any such action • Comply with legal,
            regulatory, or contractual requirements • Protect our rights, such
            as investigating, establishing, exercising, preparing for, or
            defending legal claims Vehicle Camera Images We use vehicle Camera
            Images for the following categories of limited purposes: • To
            deliver our products and services where vehicle Camera Images is
            reasonably necessary or is otherwise compatible with your reasonable
            expectations • As reasonably necessary to protect the safety,
            property, or rights of us, our 8 customers, or members of the public
            • For operations, compliance, or warranty purposes • For internal
            research or product development • To prevent, detect, protect
            against, or respond to security incidents, identity theft,
            harassment, malicious or deceptive activities, or any illegal
            activity; preserve the integrity or security of systems; or
            investigate, report, or prosecute those responsible for any such
            action • Comply with legal, regulatory, or contractual requirements
            • Protect our rights, such as investigating, establishing,
            exercising, preparing for, or defending legal claims IV. Disclosing
            and selling of Personal Information We may disclose the Personal
            Information we collect about you to our affiliates and the
            categories of third parties listed in this section. Some of these
            disclosures may qualify as “sales” under some state laws.
            Disclosures We may disclose Personal Information within GM,
            including to GM affiliates. We also may disclose Personal
            Information to the following categories of third parties: • To GM
            dealers and their service providers to deliver their products and
            services to you and to GM licensees; however, transaction
            information regarding your My GM Rewards Card program will not be
            provided to GM dealers • To our service providers who work on our
            behalf and who do not have an independent right to use the Personal
            Information, such as companies that administer our contests and
            promotions, host or operate our websites, send communications,
            perform data analytics; or process, store, or manage credit card
            information • To fleet owners, dealers or rental car companies, for
            service or maintenance of their vehicles that you may use • To
            emergency service providers and roadside assistance providers to
            deliver related services and to protect your safety or the safety of
            others (for example, to help you in an emergency) • To wireless
            service providers, to deliver cellular or Wi-Fi connectivity to your
            vehicle (e.g. AT&T) • To third parties where you have chosen to
            receive a service from them or authorized them to request data from
            GM (for example, financial organizations who offer financing for the
            purchase or lease of GM vehicles or the My GM Rewards GM Card
            program) • To third parties for research and development purposes
            (such as university research institutes for improving highway
            safety) • In connection with the sale, transfer or financing of a GM
            business or its assets, including any such activities associated
            with a bankruptcy proceeding 9 • As required or permitted by law,
            such as to comply with a civil, criminal, or regulatory inquiry,
            investigation, subpoena, or summons by federal, state, local, or
            other governmental authorities • As permitted by law, such as (a)
            when we believe in good faith that disclosure is necessary to
            protect our rights, your safety, or the safety of others, (b) to
            prevent, detect, protect against, or respond to security incidents,
            identity theft, fraud, harassment, malicious or deceptive
            activities, or other illegal activity, or preserve the integrity or
            security of systems, (c) to investigate, establish, exercise,
            prepare for, or defend legal claims, or (d) to conduct screening to
            ensure you are not on any government list of restricted parties
            Disclosures that may qualify as “sales” We may disclose the Personal
            Information listed below to the following categories of third
            parties which may qualify as “sales” under some state laws: •
            Identifiers and Digital Activity Information may be disclosed to
            companies with which GM enters into business or marketing
            arrangements, such as third-party advertising networks • Identifiers
            and Digital Activity Information may be disclosed to companies with
            which GM enters into business or marketing arrangements, such as
            information regarding usage of the infotainment system to SiriusXM
            Connected vehicle Personal Information disclosures When you enroll
            in OnStar, GM may disclose Driver Behavior Information, precise
            Geolocation Information, and Camera Images collected from the
            vehicle for the limited purposes outlined below. Driver Behavior
            Information We may disclose Driver Behavior Information collected
            from connected vehicles to our affiliates and categories of third
            parties for the following limited purposes: • Where you have chosen
            to receive a product or service from a third party or affiliate or
            have authorized them to request data from GM • Where you have given
            your affirmative consent to disclose Driver Behavior Information
            with General Motors Insurance for usage-based insurance offers or to
            help determine your rate for an insurance quote or policy • Service
            providers who work on our behalf and who do not have an independent
            right to use the Driver Behavior Information, such as companies that
            help us develop our products and services or perform data analytics
            • Fleet owners, dealers, or rental car companies, for service or
            maintenance of their vehicles that you may use • Emergency service
            to deliver services and to protect life or physical safety (for 10
            example, to help you in an emergency) • Affiliates or third parties
            for research and development purposes (such as university research
            institutes for improving highway safety) • As permitted by law, such
            as (a) when we believe in good faith that disclosure is necessary to
            protect our rights, your safety, or the safety of others, (b) to
            prevent, detect, protect against, or respond to security incidents,
            identity theft, fraud, harassment, malicious or deceptive
            activities, or other illegal activity, or preserve the integrity or
            security of systems, or (c) to investigate, establish, exercise,
            prepare for, or defend legal claims • As reasonably necessary to
            comply with a lawful government request, regulatory requirement,
            legal order, or similar obligation, which must be in the form of a
            warrant or court order, absent exigent circumstances or applicable
            statutory authority Precise Geolocation Information We may disclose
            precise Geolocation Information collected from connected vehicles to
            our affiliates and the following categories of third parties for the
            following limited purposes: • Where you have chosen to receive a
            product or service from a third party or affiliate or have
            authorized them to request data from GM • Service providers who work
            on our behalf and who do not have an independent right to use the
            precise Geolocation Information, such as companies that help us
            develop our products and services or companies that help GM analyze
            data • Fleet owners, dealers, or rental car companies, for service
            or maintenance of their vehicles that you may use • Emergency
            service and roadside assistance providers to deliver services and to
            protect life or physical safety (for example, to help you in an
            emergency) • Affiliates or third parties for research and
            development purposes (such as university research institutes for
            improving highway safety) • As permitted by law, such as (a) when we
            believe in good faith that disclosure is necessary to protect our
            rights, your safety, or the safety of others, (b) to prevent,
            detect, protect against, or respond to security incidents, identity
            theft, fraud, harassment, malicious or deceptive activities, or
            other illegal activity, or preserve the integrity or security of
            systems, or (c) to investigate, establish, exercise, prepare for, or
            defend legal claims • As reasonably necessary to comply with a
            lawful government request, regulatory requirement, legal order, or
            similar obligation, which must be in the form of a warrant or court
            order, absent exigent circumstances or applicable statutory
            authority Vehicle Camera Images 11 We may disclose Camera Images
            collected from connected vehicles to our affiliates and the
            following categories of third parties for the following limited
            purposes: • Service providers who work on our behalf and who do not
            have an independent right to use the vehicle Camera Images, such as
            companies that help us develop our products and services • As
            permitted by law, such as (a) when we believe in good faith that
            disclosure is necessary to protect our rights, your safety, or the
            safety of others, (b) to prevent, detect, protect against, or
            respond to security incidents, identity theft, fraud, harassment,
            malicious or deceptive activities, or other illegal activity, or
            preserve the integrity or security of systems, or (c) to
            investigate, establish, exercise, prepare for, or defend legal
            claims • As reasonably necessary to comply with a lawful government
            request, regulatory requirement, legal order, or similar obligation,
            which must be in the form of a warrant or court order, absent
            exigent circumstances or applicable statutory authority V. Sharing
            or transferring your connected vehicle The nature of our connected
            vehicles means that there may be circumstances where you might let
            someone else use a product or service that we provide to you (for
            example, you enrolled your vehicle in OnStar and then let someone
            else drive the vehicle). It is important that if you do let someone
            else use one of our products or services that you inform them of
            this Privacy Statement and of the privacy choices that you have
            made. If you sell or otherwise transfer your vehicle, we strongly
            encourage you to delete all Personal Information (such as contacts,
            address searches, saved map addresses, or preferences) from the
            vehicle and contact us to transfer or cancel your account. If you do
            not delete this Personal Information, it may remain in the vehicle
            and may be accessible to future users of the vehicle. For
            instructions on how to delete Personal Information from your
            vehicle, please refer to your owner’s manual. VI. Marketing and
            communications GM uses Personal Information to market and
            communicate with you. You can adjust these preferences or access and
            update your details as described below. i. Marketing and
            communications preferences Communications with you may be via mail,
            telephone, e-mail, text message, and other electronic messages,
            through the in-vehicle infotainment or OnStar system or via our
            websites and applications. Texting with GM is subject to the GM
            Consolidated Texting Policy (Texting Policy), available at
            <a href="https://www.gm.com/texting-policy">
              {" "}
              https://www.gm.com/texting-policy
            </a>
            To opt out of receiving text messages from GM, you should follow the
            opt-out instructions in that specific text message program or visit
            our Texting Policy for more information. If you have 12 opted in to
            any of our text message programs and you later decide to change your
            phone number or cancel your phone plan you should immediately optout
            of any text message programs and re-opt in with your new phone
            number if you wish to continue to receive text messages from GM.
            This will help us ensure we continue to honor your preferences and
            text the correct phone number. If you do not want to receive
            marketing communications from GM, please visit our Consumer
            Preference System website at
            <a href="https://www.gmcontactpreferences.com">
              {" "}
              https://www.gmcontactpreferences.com
            </a>
            This will allow you to opt out of communications or to change
            previously submitted opt-out preferences. You can also call
            1-866-MYPRIVACY (1-866-697-7482) to opt out of direct mail
            communications, as well as telephone and email communications, or to
            change previously submitted opt-out preferences. When you opt out of
            receiving marketing communications from GM, Personal Information
            about you may still be used for the other transactional and
            service-related purposes described in this Privacy Statement (such
            as vehicle support and service). To unsubscribe from a particular
            email newsletter or other communication (such as My GMLINK Service
            Reminders), you should follow the instructions in the email or on a
            related website. ii. Targeted advertising Our ad networks may offer
            ways to adjust your preferences for online behavioral advertising,
            including the Digital Advertising Alliance's Self-Regulatory
            Principles for Online
            <a href="https://AboutAds.info"> https://AboutAds.info</a>. If you
            do not wish to receive personalized advertising or content from us
            while visiting non-GM websites, you may click on the AdChoices icon
            or link located at the bottom of our websites, where available, to
            learn more about the companies GM uses for personalized advertising
            or by visiting the Digital Advertising Alliance’s Opt-Out page for
            instructions on how to opt out. Opting out of personalized
            advertising will not opt you out of all GM advertising, but rather
            only those GM advertisements that are personalized to your interests
            by the companies GM uses to display advertising on non-GM sites.
            After opting out of personalized advertising, you may still continue
            to see GM advertisements on non-GM websites based upon your
            interactions with the non-GM websites on which our advertisements
            appear. iii. Access and update your account and contact information
            You can access your online account to view or update Personal
            Information about you in that account. You may also contact us, as
            provided below, to learn about how to access, review, correct or
            update the Personal Information about you in our records. We may
            need to retain certain Personal Information for recordkeeping
            purposes, to complete any transactions that you began prior to your
            request, or for other purposes as required or permitted by
            applicable law. 13 You may contact us, as provided below, to learn
            about how to update your mail, email or telephone information.
            Please call one of the following Customer Assistance Centers that is
            specific to your vehicle: • Buick: 1-800-521-7300 • Cadillac:
            1-800-458-8006 • Chevrolet: 1-800-222-1020 • GMC: 1-800-462-8782 •
            OnStar: 1-888-466-7827 • Saturn: 1-800-553-6000 • HUMMER (2010 and
            prior model years): 1-866-486-6376 • Pontiac: 1-800-762-2737 For
            inquiries about how the Personal Information you submit to the
            Investors portion of GM’s website or to GM Stockholder Services is
            handled, please call 1-313-667-1432. You may update My GM Rewards
            Cards contact information, such as name, address, phone number and
            email address, by logging onto the Account portion of the website
            listed on the back of your card. You can refer to the back of your
            credit card for customer assistance phone numbers for your account
            needs. You may withdraw from participation in the My GM Rewards
            program at any time by contacting a My GM Rewards Member Support
            Specialist at 1-844-764-2665. If you have a question or concern
            about the privacy practices of the My GM Rewards Cards or the My GM
            Rewards Card websites, please contact us by sending an email from
            the Contact Us section. For a complete description of the most
            current eligible transactions, benefits and participating companies,
            as well as details on earning and redeeming points, go to{" "}
            <a href="https://experience.gm.com/rewards">{" "}
              https://experience.gm.com/rewards
            </a>
            where you live, you may have certain rights related to Personal
            Information about you. To exercise the rights described below, or to
            see what rights may be available in your state, please submit a
            verifiable consumer request to us by either: • Visiting GM’s U.S.{" "}
            <a href="https://www.gm.com/consumer-privacy">
              Consumer Privacy Request Form
            </a>
            (1-866-697-7482) We do not accept consumer privacy requests made by
            email. Privacy rights The privacy rights available to you are based
            on the state in which you reside. These rights may include: 14 •
            Access my Personal Information • Obtain a copy of my Personal
            Information • Correct my Personal Information • Delete my Personal
            Information • Opt out of processing my Personal Information for
            targeted advertising (in California, this is called “Do Not Share My
            Personal Information”) • Opt out of selling my Personal Information
            • Opt out of certain types of automated processing Processing
            expectations We do not discriminate against consumers who exercise
            these rights. We take reasonable steps to respond to all requests
            and will work to process your request in accordance with the laws
            that apply where you reside. Our processing time may vary, and in
            some cases, we may require up to 45 days to process your request. We
            may retain the Personal Information you submit with your request for
            as long as required or permitted by applicable law. Authorizing an
            agent You may be permitted by law to authorize someone else to act
            as your agent to exercise some of your privacy rights on your
            behalf. In such cases, your authorized agent must provide
            documentation supporting his or her authority to make this request
            on your behalf. In some cases, we may also require you to verify
            your identity directly with us and confirm the request before we
            will process it. Further information about how to submit this
            request and the documentation we require to support it is available
            within our U.S. Consumer Privacy Request Form at{" "}
            <a href="https://consumerprivacy.gm.com">
              https://consumerprivacy.gm.com
            </a>
            Your authorized agent can also contact us at{" "}
            <a href="mailto:gm.datacompliance@gm.com">
              gm.datacompliance@gm.com
            </a>{" "}
            to request a copy of our Authorized Agent Form and to submit this
            request on your behalf. Documentation supporting your authorized
            agent’s right to submit this request on your behalf, such as a copy
            of our Authorized Agent Form signed by you or a Power of Attorney,
            must be submitted with this request. If this request is submitted
            over the phone, your authorized agent will be asked to email
            supporting documentation to{" "}
            <a href="mailto:gm.datacompliance@gm.com">
              gm.datacompliance@gm.com
            </a>
            . Verifying your request For your protection, we take reasonable
            steps to verify all requests before they are processed. This may
            include, for example, a request from us for you to confirm your
            identity, to validate documents you submit to us, to verify your
            authority to make the request, or for other purposes. In all cases,
            we reserve the right to deny your request in accordance with
            applicable law if we cannot verify you or your authority to make the
            15 request. If we decline to take action regarding your request, you
            may have the right to appeal. Please contact us at{" "}
            <a href="mailto:gm.datacompliance@gm.com">
              gm.datacompliance@gm.com
            </a>{" "}
            if you would like to submit such an appeal. Global Privacy Control
            Our websites respond to the Global Privacy Control (GPC) signal when
            we detect that it is enabled on the particular web browser used to
            access our websites. We respond to your web browsers GPC setting
            each time you visit our websites. When we detect the GPC signal, we
            honor this as your request to opt out of “sales” and certain types
            of targeted advertising at the web browser-level by turning off data
            collection by some website cookies and tracking technologies. We
            will not honor a prior web browser setting if you disable GPC in the
            web browser used to access our websites between visits to our
            websites, or if you later visit our websites from different devices
            or browsers that does not send the GPC signal. More information on
            how to use the GPC signal, including supported browsers, is
            available at{" "}
            <a href="https://globalprivacycontrol.org/">
              https://globalprivacycontrol.org/
            </a>
            . At this time, we do not honor “Do Not Track” signals if enabled in
            a web browser. VIII. How we safeguard Personal Information We
            maintain reasonable technical, administrative, and physical security
            and confidentiality measures designed to help protect Personal
            Information from unauthorized access or use. We also require (other
            than in certain emergency situations) third party service providers
            acting on our behalf or with whom we disclose Personal Information
            to provide similar security and confidentiality measures. Learn more
            about cybersecurity at GM by visiting{" "}
            <a href="https://gm.com/cybersecurity">
              https://gm.com/cybersecurity
            </a>
            . IX. How long we keep Personal Information We may keep the Personal
            Information we collect for as long as necessary for the purposes
            described in this Privacy Statement. Where required, we will
            de-identify or dispose of the Personal Information we collect when
            we no longer need it for the uses described in this Privacy
            Statement. X. Childrens privacy GM websites and other online
            services do not target or knowingly collect any Personal Information
            from children under the age of 13. XI. International transfers of
            Personal Information When GM and its affiliates in the United
            States, including OnStar, (GM U.S.), receive 16 Personal Information
            from GM and affiliates outside the United States, (Non-U.S.
            Companies), we comply with applicable legal requirements providing
            adequate protection for the transfer of Personal Information to
            third countries. We may store Personal Information in the United
            States, the European Economic Area (EEA), and other locations where
            we or our service providers maintain servers. With respect to such
            transfers from the EEA to the United States and other non-EEA
            jurisdictions, we implement standard contractual clauses and other
            mechanisms to protect such data. Individuals that use products or
            services offered by Non-U.S. Companies may wish to raise any privacy
            questions with such company directly, including filing any requests
            to access customer data or exercise other privacy rights. Each
            Non-U.S. Company has a separate privacy statement that you can find
            by visiting its website. Individuals may also raise questions with
            GM U.S. using the contact details below. In addition, anonymized and
            aggregated data from Non-U.S. Companies are shared with GM U.S. to
            evaluate or research the safety, quality, usage, and functionality
            of vehicles and services; to provide Non-U.S. Company customers with
            vehicle support and services; and to ensure accurate customer
            records and maintain customer relationships. Personal Information is
            also shared with GM U.S. in order to contact Non-U.S. Company
            customers about their vehicle or the services, or for marketing
            purposes, but only if the individual has opted in to receive
            marketing communications. XII. How to contact us If you have
            concerns or questions regarding GM's consumer privacy practices or
            this Privacy Statement you may contact us at 1-866-MYPRIVACY
            (1-866-697-7482). You may also contact GM Privacy by mail at Attn:
            GM Privacy, P.O. Box 1027, Warren, Michigan USA 48090-1027 or by
            email at <a href="mailto:privacy@gm.com"> privacy@gm.com</a>. XIII.
            Changes to this Privacy Statement We may amend this Privacy
            Statement from time to time. In some cases, we will notify you of
            this change by posting a new effective date at the top of this
            Privacy Statement and your continued use of our products and
            services covered by this Privacy Statement will mean you accept the
            changes. When there is a material change to this Privacy Statement,
            then we will notify you as required by law, such as by email or
            through a notice on the applicable website.
          </p>
        </div>
        <div className="input-button">
          <div className="optional-message">
          Please enter your GM Energy PowerShift Charger or Home Hub serial number. To locate the serial number please check the Quick Installation Guide (QIG) or the bottom of the hardware product.
          </div>
          <div className="optional-input">
            <TextField
              variant="outlined"
              size="small"
              value={serialNumber}
              onChange={(e) => handleInputChange(e.target.value)}
              className="sn-input"
              placeholder="Serial Number"
              InputProps={{
                style: {
                  color: "white",
                },
              }}
              error={!isValidInput}
              helperText={isValidInput ? "" : "Only letters and numbers are allowed."}
            />
          </div>
        </div>
        <div className="accept-checkbox">
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                color="primary"
                style={{ color: error && !isChecked ? "red" : "inherit" }}
              />
            }
            label={
              <span className="checkbox-label">
                By checking this box, I attest that I have read and agreed to the GM Energy Terms and Conditions and Privacy Policy.
              </span>
            }
          />
          {error && !isChecked && (
            <p className="error-text">
              {error.includes("terms") &&
                "Please accept the terms and conditions."}
            </p>
          )}
        </div>
        <div className="next-button">
          <Button
            variant="contained"
            color="primary"
            onClick={handleAccept}
            disabled={!isChecked || serialNumber === ""}
          >
            Accept
          </Button>
        </div>
      </div>
      <FooterPage />
    </Box>
  );
};

TermsAndConditions.propTypes = {
  onAccept: PropTypes.func.isRequired,
};

export default TermsAndConditions;
